import { useQuery } from '@apollo/client'
import { FETCH_CANCELLATION_METRICS } from '@/gf/queries/metrics'
import { CancellationMetrics, MetricsVars } from '../../types'

interface FetchCancellationMetricsData {
  fetchCancellationMetrics: CancellationMetrics
}
type FetchCancellationMetricsVars = MetricsVars

const useCancellationMetrics = ({
  fromDate,
  toDate,
  selectedStoreId,
}: FetchCancellationMetricsVars) => {
  const { loading, error, data } = useQuery<
    FetchCancellationMetricsData,
    FetchCancellationMetricsVars
  >(FETCH_CANCELLATION_METRICS, {
    variables: { fromDate, toDate, selectedStoreId },
    fetchPolicy: 'no-cache',
  })

  return { loading, error, data: data?.fetchCancellationMetrics }
}

export default useCancellationMetrics
